<template>
  <!-- 对话框 -->
  <el-dialog title="用户钱包" :visible.sync="show" :before-close="closeDialog" style="width:60%; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <el-form label-width="80px">

        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 100px; text-align: right; margin-right: 10px;">提现中:</span>
          {{ form.cashing }} 元
        </p>
        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 100px; text-align: right; margin-right: 10px;">余额:</span>
          {{ form.total_balance }} 元（现金券：{{form.price}}，充值余额：{{form.balance}}）

        </p>
        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 100px; text-align: right; margin-right: 10px;">已提现:</span>
          {{ form.cash }} 元
        </p>
        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 100px; text-align: right; margin-right: 10px;">已冻结:</span>
          {{ form.frozen }} 元
        </p>
        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 100px; text-align: right; margin-right: 10px;">拖欠款:</span>
          {{ form.arrears }} 元
        </p>


        <el-button @click="edit_wallet = !edit_wallet" style="margin: 20px auto;display: block;">更改用户钱包</el-button>

        <div v-if="edit_wallet">
          <el-form-item label="操作方式:" label-width='120px'>
            <el-radio-group v-model="submit_data.operation">
              <el-radio-button label="balance">余额</el-radio-button>
              <el-radio-button label="cash">已提现</el-radio-button>
              <el-radio-button label="frozen">已冻结</el-radio-button>
              <el-radio-button label="arrears">拖欠款</el-radio-button>
              <el-radio-button label="price">现金券</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="模式:" label-width='120px'>
            <el-radio-group v-model="submit_data.mode">
              <el-radio-button label="add">+</el-radio-button>
              <el-radio-button label="sub">-</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="金额:" label-width='120px'>
            <el-input v-model="submit_data.amount" :placeholder="submit_rules.amount.placeholder">
            </el-input>
          </el-form-item>

          <el-form-item label="备注:" label-width='120px'>
            <el-input v-model="submit_data.remark" type="textarea">
            </el-input>
          </el-form-item>

        </div>
      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="walletSubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.consumer_code = _this.data;
        console.log(_this.data);

        _this.walletInit();

      },

    },
    data() {
      return {

        show: false,

        // 修改钱包按钮开关
        edit_wallet: false,

        // 表单数据
        form: {
          cash: '0.00',
          balance: '0.00',
          cashing: '0.00',
          frozen: '0.00',
          arrears:'0.00',
          total_balance:'0.00',
          price:'0.00'
        },

        // 表单提交数据
        submit_data: {
          consumer_code: '',
          mode: '',
          operation: '',
          amount: '',
          remark:''
        },

        submit_rules: {
          mode: {
            placeholder: '模式',
            rules: {
              required: true,
              message: '未选择模式',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          operation: {
            placeholder: '操作方式',
            rules: {
              required: true,
              message: '未选择操作模式',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          amount: {
            placeholder: '请输入金额',
            rules: {
              required: true,
              message: '未输入金额',
              regulation: 'gt_str',
              rulesData: 0
            }
          }

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {
      // 获取钱包信息
      walletInit(){
        _this.$post(
            '/consumer/getConsumerWalletDetails', {
              consumer_code: _this.submit_data.consumer_code
            }
          )
          .then(res => {

            // 将获取到的数据赋值
            _this.form.cashing=res.data.cashing;
            _this.form.balance=res.data.balance;
            _this.form.cash=res.data.cash;
            _this.form.frozen=res.data.frozen;
            _this.form.arrears=res.data.arrears;
            _this.form.balance = res.data.balance;
            _this.form.total_balance = res.data.total_balance;
            _this.form.price = res.data.price
            console.log(res.data);


          }).catch((err) => {

          })
      },
      // 关闭方法
      closeDialog() {

        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

        _this.form = {
          cash: '0.00',
          balance: '0.00',
          cashing: '0.00',
          frozen: '0.00',
          arrears:'0.00',
          total_balance:'0.00',
          price:'0.00'
        };

      },

      // 提交按钮
      walletSubmit() {

        _this.$post(
            '/consumer/editConsumerWallet',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            console.log(res);

            _this.$message.success('更改成功');

            // 重新获取钱包信息
            _this.walletInit();
            _this.closeDialog();
            _this.$emit('onSubmit');


          }).catch((err) => {

          })

      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>
